import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@clerk/clerk-react";
import { getApiClient } from "./api-client";

export interface CurrentUser {
  id: string;
  email: string;
  username: string | null;
  displayName: string | null;
  image: string | null;
  isAdmin: boolean;
  isFacilitator: boolean;
}

export function useCurrentUser() {
  const { isLoaded, isSignedIn } = useAuth();

  return useQuery<CurrentUser>({
    queryKey: ["auth", "me"],
    enabled: isLoaded && isSignedIn,
    queryFn: () => getApiClient().get<CurrentUser>("/auth/me"),
    staleTime: 5 * 60 * 1000,
  });
}
